import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import { each, find, first } from 'lodash';
import moment from 'moment';
import Fa from 'react-fontawesome';

import { Dropdown, MenuItem, ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import NumberDisplay from '../../../../components/number-display';
import MoneyDisplay from '../../../../components/money-display';
import Counter from '../../../../components/counter';
// Import Selectors
import {
  getStats, getWinRates, getPeriodCurrent, getPeriodTotal,
  getPeriodRange, getSyncDate,
  getUseForecastAccuracies, getForecastAccuracies,
} from '../../ForecastReducer';
import { getOrganizationLastSyncDate, getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getViewableDimensions } from '../../../App/AppReducer';
import styles from './style.css';

const USER_PREFERENCE_WIN_RATE = 'forecast-win-rate';
class ForecastTable extends Component {
  constructor(args) {
    super(args);
    this.state = {
      winRate: 'three_months',
      selectedDealType: null,
      selectedForecastType: null,
    };
  }

  componentWillMount() {
    const { userPreferences } = this.context;
    const winRate = userPreferences[USER_PREFERENCE_WIN_RATE] || 'three_months';
    this.setState({ winRate });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedForecastType !== this.props.selectedForecastType) {
      this.setState({ selectedForecastType: nextProps.selectedForecastType });
    }
  }

  setWinRate(winRate) {
    this.setState({ winRate });
    this.context.updateUserPreference(USER_PREFERENCE_WIN_RATE, winRate);
  }

  getRate(winRate) {
    const {
      winRates, useForecastAccuracies, forecastAccuracies,
    } = this.props;
    const rateValues = useForecastAccuracies ? forecastAccuracies : winRates;
    return rateValues[winRate] || 0;
  }

  renderDropdown() {
    const {
      periodCurrent, periodTotal, periodRange, isFuture,
      useForecastAccuracies,
    } = this.props;
    const { winRate } = this.state;
    const percentage = periodTotal !== 0 ? (periodCurrent / periodTotal) * 100 : 0;
    const daysLeft = periodTotal - periodCurrent;
    const daysSuffix = ` ${pluralize('day', daysLeft)} left`;
    const rates = [
      {
        label: '3 Months',
        value: 'three_months',
      },
      {
        label: '6 Months',
        value: 'six_months',
      },
      {
        label: '12 Months',
        value: 'twelve_months',
      },
    ];
    const selected = find(rates, { value: winRate });
    const rateType = useForecastAccuracies ? 'Forecast Accuracy' : 'Win Rate';
    const r = this.getRate(winRate);

    return (
      <div>
        <div className="row">
          <div className="col-sm-6">
            {!isFuture && <div>
              <div className="clearfix">
                <div className="pull-left">
                  <Counter value={percentage}>
                    <NumberDisplay value={percentage} precision={1} suffix={`% of ${periodRange}`} />
                  </Counter>
                </div>
                <div className="pull-right text-danger">
                  <Counter value={daysLeft}>
                    <NumberDisplay value={daysLeft} precision={0} suffix={daysSuffix} />
                  </Counter>
                </div>
              </div>
              <ProgressBar>
                <ProgressBar striped bsStyle="success" now={percentage} key={1} />
                <ProgressBar striped bsStyle="danger" now={100 - percentage} key={2} />
              </ProgressBar>
            </div>}
          </div>
          <div className="col-sm-6">
            <div className="pull-right">
              <div className="sub-header-with-controls">
                <span className="text-danger">Risk based on trailing &nbsp;</span>
                <Dropdown id="percentage">
                  <Dropdown.Toggle bsSize="sm">
                    {selected.label}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {rates.map(rate => (<MenuItem key={rate.value} active={rate.value === selected.value} onClick={() => { this.setWinRate(rate.value); }}>
                      <span>{rate.label} (<NumberDisplay value={this.getRate(rate.value) * 100} precision={1} suffix="%" />)</span>
                    </MenuItem>))}
                  </Dropdown.Menu>
                </Dropdown>
                {' '}
                <nobr>
                  {rateType}:&nbsp;
                  <strong>
                    <Counter value={r * 100}>
                      <NumberDisplay value={r * 100} precision={1} suffix="%" />
                    </Counter>
                  </strong>
                </nobr>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderString(count, opt = {}) {
    const { clickable } = this.props;
    const comp = (<nobr><MoneyDisplay value={count} precision={1} abbreviated /></nobr>);
    if (count > 0 && clickable) {
      const { dealType, forecastType } = opt;
      const { selectedDealType, selectedForecastType } = this.state;
      const active = selectedDealType === (dealType || null) &&
        selectedForecastType === (forecastType || null);
      const newState = {
        selectedDealType: dealType || null,
        selectedForecastType: forecastType || null,
      };
      if (active) {
        return (<strong className="animated flash">{comp}</strong>);
      }
      return (<a
        href
        onClick={(e) => {
          e.preventDefault();
          this.setState(newState);
          this.props.onCellClick(opt);
        }}
      >
        {comp}
      </a>);
    }
    return comp;
  }

  renderNumberDisplay(num, colorCode = false, withPlus = false) {
    const isPossitive = num > 0;
    const isNegative = num < 0;
    if (num === 0) {
      return null;
    }
    let cls = 'label-default';
    if (colorCode) {
      if (isPossitive) {
        cls = 'label-success';
      } else if (isNegative) {
        cls = 'label-danger';
      }
    }

    return (
      <span className={`label ${cls}`}>
        <NumberDisplay value={num} precision={1} suffix="%" withPlus={withPlus} />
      </span>
    );
  }

  renderMoneyDisplay(num, colorCode = false, withPlus = false) {
    const isPossitive = num > 0;
    const isNegative = num < 0;
    let cls = '';
    if (colorCode) {
      if (isPossitive) {
        cls = 'text-success';
      } else if (isNegative) {
        cls = 'text-danger';
      }
    }
    return (
      <nobr className={cls}>
        <MoneyDisplay value={num} precision={1} abbreviated withPlus={withPlus} />
      </nobr>
    );
  }

  renderTitle() {
    const { location: { pathname } } = this.props;

    const items = [
      {
        label: 'Current Forecast',
        value: '/forecast/current',
        description: 'Forecast amounts are not adjusted and represent the total amount for each opportunity forecasted for the selected forecast period.',
      },
      {
        label: 'Weighted Forecast',
        value: '/forecast/current/weighted',
        description: 'Forecast amounts are adjusted for actual win rates by sales rep and opportunity type over the past twelve months',
      },
    ];
    const activeItem = find(items, { value: pathname }) || first(items);

    return [
      (
        <Dropdown key="control" id="sub=pages" className={styles.titleDropdown}>
          <Dropdown.Toggle bsStyle="link" bsSize="lg">
            <h4 className="page-sub-header">{activeItem.label}</h4>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {items.map((item) => {
              const active = item.value === pathname;
              return (
                <MenuItem key={item.value} active={active} onClick={() => { this.context.router.history.push(item.value); }}>
                  {item.label}
                </MenuItem>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      ),
      (
        <div key="description"><p><Fa name="info-circle" className="text-active" /> {activeItem.description}</p></div>
      ),
    ];
  }

  render() {
    const {
      stats, organization, syncDate,
      organizationLastSyncDate, isHistory, isFuture,
    } = this.props;

    let suffix = '';
    let symbol = '';
    if (organization) {
      suffix = organization.currency_suffix || '';
      symbol = organization.currency_symbol || '';
    }
    const columnWidth = 100 + ((suffix.length + symbol.length) * 5);

    const percentage = this.getRate(this.state.winRate);

    const finalStats = [];
    const total = {
      beginningForecast: 0,
      currentForecast: 0,
      forecastChange: 0,
      paceVSForecast: 0,
      PTDWins: 0,
      projectedResults: 0,
      projectedAccuracy: 0,
      forecastRisk: 0,
      lost: 0,
      noDecision: 0,
      closedWon: 0, // newWon + won
      newWon: 0,
      forecastWon: 0, // actual amount
      won: 0,
      new: 0,
      slipped: 0,
      accuracy: 0,
    };
    each(stats, (stat) => {
      const newStat = { ...stat };
      newStat.projectedResults = (newStat.currentForecast * percentage) + newStat.PTDWins;
      newStat.projectedAccuracy = newStat.beginningForecast ? newStat.projectedResults / newStat.beginningForecast : 0;
      newStat.forecastRisk = newStat.beginningForecast - newStat.projectedResults;

      total.beginningForecast += newStat.beginningForecast;
      total.currentForecast += newStat.currentForecast;
      total.paceVSForecast += newStat.paceVSForecast;
      total.PTDWins += newStat.PTDWins;

      total.forecastChange = total.beginningForecast ? total.paceVSForecast / total.beginningForecast : 0;
      total.projectedResults = (total.currentForecast * percentage) + total.PTDWins;
      total.projectedAccuracy = total.beginningForecast ? total.projectedResults / total.beginningForecast : 0;
      total.forecastRisk = total.beginningForecast - total.projectedResults;

      total.lost += newStat.lost;
      total.won += newStat.won;
      total.new += newStat.new;
      total.slipped += newStat.slipped;
      total.noDecision += newStat.noDecision || 0;
      total.closedWon += newStat.closedWon || 0;
      total.newWon += newStat.newWon || 0;
      total.forecastWon += newStat.forecastWon || 0;
      finalStats.push(newStat);
    });
    const won = isHistory ? total.closedWon : total.won;
    total.accuracy = total.beginningForecast > 0 ? won / total.beginningForecast : 0;
    const greenBg = 'rgba(223, 240, 216, 0.5)';
    const redBg = 'rgba(249, 189, 187, 0.3)';
    // const blueBg = 'rgba(33, 150, 243, 0.1)';
    const orangeBg = 'rgba(255, 152, 0, 0.1)';
    // const purpleBg = 'rgba(149, 117, 205, 0.1)';
    const greyBg = 'rgba(204, 204, 204, 0.2)';
    const startDate = syncDate ? syncDate.format('MMMM DD, YYYY') : null;
    const lastSyncDate = organizationLastSyncDate ? organizationLastSyncDate.format('MMMM DD, YYYY') : null;

    const beginningForecastPopover = (
      <Tooltip id="beginning-forecast-popover" title="Beginning Forecast">
        Recorded on {startDate}
      </Tooltip>
    );
    const currentForecastPopover = (
      <Tooltip id="current-forecast-popover" title="Current Forecast">
        Last captured on {lastSyncDate}
      </Tooltip>
    );

    const ptdPopover = (
      <Tooltip id="ptd-popover" title="PTD Wins">
        Amount won as of {lastSyncDate} for the currently selected forecast period
      </Tooltip>
    );
    const projectedResultsPopover = (
      <Tooltip id="projected-results-popover" title="Projected Results">
        <span>
          Uses historical forecast accuracy or win rates to predict your results based on the beginning forecast
        </span>
      </Tooltip>
    );
    const forecastRiskPopover = (
      <Tooltip id="forecast-risk-popover" title="Forecast Delta">
        The delta between the period&rsquo;s projected results and the beginning forecast for the period.
      </Tooltip>
    );


    const closedWonPopover = (
      <Tooltip id="close-won-popover" title="Total Won">
        Total amount won in the currently selected period.
      </Tooltip>
    );
    const forecastAccuracyPopover = (
      <Tooltip id="forecast-accuracy-popover" title="Forecast Accuracy">
        Percentage of the beginning forecast amount that was closed won in the selected period.
      </Tooltip>
    );
    const wonForecastPopover = (
      <Tooltip id="won-forecast-popover" title="Won Forecast">
        Amount won that in the beginning forecast for the currently selected period.
      </Tooltip>
    );
    const wonNewPopover = (
      <Tooltip id="won-new-popover" title="Won New">
        Amount won that was not in the beginning forecast for the currently selected period.
      </Tooltip>
    );
    const newPopover = (
      <Tooltip id="new-popover" title="New">
        Amount of closed (won, lost, and/or no decision) opportunities added to the currently selected period after the forecast period began.
      </Tooltip>
    );
    const slippedPopover = (
      <Tooltip id="slipped-popover" title="Slipped">
        Forecasted amount that was subsequently moved to close on a date outside of the currently selected period.
      </Tooltip>
    );
    const lostPopover = (
      <Tooltip id="lost-popover" title="Lost">
        Amount that was closed as lost for the currently selected period.
      </Tooltip>
    );
    const noDecisionPopover = (
      <Tooltip id="no-decision-popover" title="No Decision">
        Amount that was closed as a no decision for the currently selected period.
      </Tooltip>
    );
    const ptdChangeChangePopover = (
      <Tooltip id="ptd-change" title="PTD Change">
        Amount the current forecast has changed since the beginning of the forecast period.
      </Tooltip>
    );

    const space = (<th style={{ width: '3px', padding: 0, background: '#ccc' }} />);

    return (
      <div className={!isHistory ? styles.wrapper : null}>
        <div className="container">
          {!isHistory &&
            <div>
              {this.renderTitle()}
              {this.renderDropdown()}
              <p />
            </div>
          }
          <table className={`table table-bordered table-striped ${styles.table}`}>
            <thead>
              <tr>
                <th width="150">Opportunity Type</th>
                {!isFuture &&
                  <th className="text-center" width={columnWidth}>
                    {startDate !== null &&
                      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={beginningForecastPopover}>
                        <span>Beginning Forecast <Fa name="info-circle" className="text-active" /></span>
                      </OverlayTrigger>
                    }
                    {startDate === null && <span>Beginning Forecast</span>}
                  </th>
                }
                {!isHistory &&
                  <th className="text-center" width={columnWidth}>
                    {lastSyncDate !== null &&
                      <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={currentForecastPopover}>
                        <span>Current Forecast <Fa name="info-circle" className="text-active" /></span>
                      </OverlayTrigger>
                    }
                    {lastSyncDate === null && <span>Current Forecast</span>}
                  </th>
                }
                {!isHistory && !isFuture &&
                  <th className="text-center" width={columnWidth}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ptdChangeChangePopover}>
                      <nobr>PTD Change <Fa name="info-circle" className="text-active" /></nobr>
                    </OverlayTrigger>
                  </th>
                }
                {!isHistory && !isFuture &&
                  <th className="text-center" width={columnWidth} style={{ background: greenBg }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={ptdPopover}>
                      <span>PTD Wins <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
                {!isHistory &&
                  <th className="text-center" width={(columnWidth * 1.5)}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={projectedResultsPopover}>
                      <span>Projected Results <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
                {!isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: redBg }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={forecastRiskPopover}>
                      <span>Forecast Delta <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: greenBg }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={closedWonPopover}>
                      <span>Total Won <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={forecastAccuracyPopover}>
                      <span>Forecast Accuracy <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }

                {isHistory && space}

                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: greenBg }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={wonForecastPopover}>
                      <span>Won Forecast <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: greenBg }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={wonNewPopover}>
                      <span>Won New <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }

                {isHistory && space}

                {isHistory &&
                  <th className="text-center" width={columnWidth}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={newPopover}>
                      <span>New <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: greyBg }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={slippedPopover}>
                      <span>Slipped <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: redBg }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={lostPopover}>
                      <span>Lost <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: orangeBg }}>
                    <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={noDecisionPopover}>
                      <span>No Decision <Fa name="info-circle" className="text-active" /></span>
                    </OverlayTrigger>
                  </th>
                }
              </tr>
            </thead>

            <tbody>
              {finalStats.map((stat) => {
                return (
                  <tr key={stat.name}>
                    <td>{stat.name}</td>
                    {!isFuture &&
                      <td className="text-right">
                        <nobr>{this.renderString(stat.beginningForecast, { dealType: stat.name, forecastType: 'beginning' })}</nobr>
                      </td>
                    }
                    {!isHistory &&
                      <td className="text-right">
                        <nobr><MoneyDisplay value={stat.currentForecast} precision={1} abbreviated /></nobr>
                      </td>
                    }
                    {!isHistory && !isFuture &&
                      <td className="text-right">
                        <nobr>
                          {this.renderMoneyDisplay(stat.paceVSForecast, true, true)}
                          {' '}
                          {this.renderNumberDisplay(stat.forecastChange * 100, true, true)}
                        </nobr>
                      </td>
                    }
                    {!isHistory && !isFuture &&
                      <td className="text-right" style={{ background: greenBg }}>
                        <nobr><MoneyDisplay value={stat.PTDWins} precision={1} abbreviated /></nobr>
                      </td>
                    }
                    {!isHistory &&
                      <td className="text-right">
                        <nobr>
                          {this.renderMoneyDisplay(stat.projectedResults, false, false)}
                          {' '}
                          {this.renderNumberDisplay(stat.projectedAccuracy * 100, false, false)}
                        </nobr>
                      </td>
                    }
                    {!isHistory &&
                      <td className="text-right" style={{ background: redBg }}>
                        <nobr><MoneyDisplay value={stat.forecastRisk} precision={1} abbreviated /></nobr>
                      </td>
                    }
                    {isHistory &&
                      <td className="text-right" width={columnWidth} style={{ background: greenBg }}>
                        <nobr>{this.renderString(stat.closedWon, { dealType: stat.name, forecastType: 'won' })}</nobr>
                      </td>
                    }
                    {isHistory &&
                      <td className="text-right" width={columnWidth}>
                        <nobr><NumberDisplay value={stat.accuracy * 100} precision={1} suffix="%" /></nobr>
                      </td>
                    }

                    {isHistory && space}

                    {isHistory && ([{ type: 'forecastWon', background: greenBg }, { type: 'newWon', background: greenBg }]).map((st) => {
                      return (
                        <td key={st.type} className="text-right" width={columnWidth} style={{ background: st.background }}>
                          <nobr>{this.renderString(stat[st.type], { dealType: stat.name, forecastType: st.type })}</nobr>
                        </td>
                      );
                    })}

                    {isHistory && space}

                    {isHistory && ([{ type: 'new', background: null }, { type: 'slipped', background: greyBg }, { type: 'lost', background: redBg }, { type: 'noDecision', background: orangeBg }]).map((st) => {
                      return (
                        <td key={st.type} className="text-right" width={columnWidth} style={{ background: st.background }}>
                          <nobr>{this.renderString(stat[st.type], { dealType: stat.name, forecastType: st.type })}</nobr>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>

            <tfoot>
              <tr>
                <th><strong>Total</strong></th>
                {!isFuture &&
                  <th className="text-right">
                    {this.renderString(total.beginningForecast, { forecastType: 'beginning' })}
                  </th>
                }
                {!isHistory &&
                  <th className="text-right">
                    <nobr><MoneyDisplay value={total.currentForecast} precision={1} abbreviated /></nobr>
                  </th>
                }
                {!isHistory && !isFuture &&
                  <th className="text-right">
                    <nobr>
                      {this.renderMoneyDisplay(total.paceVSForecast, true, true)}
                      {' '}
                      {this.renderNumberDisplay(total.forecastChange * 100, true, true)}
                    </nobr>
                  </th>
                }
                {!isHistory && !isFuture &&
                  <th className="text-right" style={{ background: greenBg }}>
                    <nobr><MoneyDisplay value={total.PTDWins} precision={1} abbreviated /></nobr>
                  </th>
                }
                {!isHistory &&
                  <th className="text-right">
                    <nobr>
                      {this.renderMoneyDisplay(total.projectedResults, false, false)}
                      {' '}
                      {this.renderNumberDisplay(total.projectedAccuracy * 100, false, false)}
                    </nobr>
                  </th>
                }
                {!isHistory &&
                  <th className="text-right" style={{ background: redBg }}>
                    <nobr><MoneyDisplay value={total.forecastRisk} precision={1} abbreviated /></nobr>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: greenBg }}>
                    <nobr>{this.renderString(total.closedWon, { forecastType: 'won' })}</nobr>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth}>
                    <nobr><NumberDisplay value={total.accuracy * 100} precision={1} suffix="%" /></nobr>
                  </th>
                }

                {isHistory && space}

                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: greenBg }}>
                    <nobr>{this.renderString(total.forecastWon, { forecastType: 'won' })}</nobr>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: greenBg }}>
                    <nobr>{this.renderString(total.newWon, { forecastType: 'won' })}</nobr>
                  </th>
                }

                {isHistory && space}

                {isHistory &&
                  <th className="text-center" width={columnWidth}>
                    <nobr>{this.renderString(total.new, { forecastType: 'new' })}</nobr>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: greyBg }}>
                    <nobr>{this.renderString(total.slipped, { forecastType: 'slipped' })}</nobr>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: redBg }}>
                    <nobr>{this.renderString(total.lost, { forecastType: 'lost' })}</nobr>
                  </th>
                }
                {isHistory &&
                  <th className="text-center" width={columnWidth} style={{ background: orangeBg }}>
                    <nobr>{this.renderString(total.noDecision, { forecastType: 'noDecision' })}</nobr>
                  </th>
                }
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    stats: getStats(state),
    viewableDimensions: getViewableDimensions(state),
    winRates: getWinRates(state),
    periodCurrent: getPeriodCurrent(state),
    periodTotal: getPeriodTotal(state),
    periodRange: getPeriodRange(state),
    syncDate: getSyncDate(state),
    organizationLastSyncDate: getOrganizationLastSyncDate(state),
    organization: getUserCurrentOrganization(state),
    useForecastAccuracies: getUseForecastAccuracies(state),
    forecastAccuracies: getForecastAccuracies(state),
  };
}

ForecastTable.propTypes = {
  stats: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  viewableDimensions: PropTypes.shape({}).isRequired,
  winRates: PropTypes.shape({}).isRequired,
  selectedForecastType: PropTypes.string,
  periodCurrent: PropTypes.number.isRequired,
  periodTotal: PropTypes.number.isRequired,
  periodRange: PropTypes.string.isRequired,
  isHistory: PropTypes.bool.isRequired,
  isFuture: PropTypes.bool.isRequired,
  clickable: PropTypes.bool.isRequired,
  onCellClick: PropTypes.func.isRequired,
  organization: PropTypes.shape({}).isRequired,
  syncDate: PropTypes.instanceOf(moment),
  organizationLastSyncDate: PropTypes.instanceOf(moment),
  useForecastAccuracies: PropTypes.bool,
  forecastAccuracies: PropTypes.shape({}).isRequired,
  isWeighted: PropTypes.bool,
  location: PropTypes.shape({}).isRequired,
};

ForecastTable.defaultProps = {
  isHistory: false,
  isFuture: false,
  clickable: false,
  title: 'Current Forecast',
  onCellClick: () => {},
  selectedForecastType: null,
  useForecastAccuracies: false,
  organizationLastSyncDate: null,
  syncDate: null,
  isWeighted: false,
};

ForecastTable.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.shape({}).isRequired,
  router: PropTypes.shape({}).isRequired,
};
export default connect(mapStateToProps)(ForecastTable);
